import { ListItemIcon, ListItemText } from "@mui/material";
import { BaseSelectMenuItem } from "~/components/Form/components/SelectMenu/BaseSelectMenu/BaseSelectMenuItem";
import { KeyboardEvent } from "react";
import { Check as CheckIcon } from "@mui/icons-material";

interface Props {
  label: string;
  value: string;
  onClick?: (value: string) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLLIElement>, label: string) => void;
  isSelected: boolean;
}

export const PlainSelectMenuItem = ({
  label,
  value,
  onClick,
  onKeyDown,
  isSelected,
}: Props) => {
  return (
    <BaseSelectMenuItem
      label={label}
      value={value}
      onClick={onClick}
      key={label}
      onKeyDown={(event) => onKeyDown?.(event, value)}
    >
      <ListItemText primary={label} />
      {isSelected && (
        <ListItemIcon>
          <CheckIcon fontSize="inherit" sx={{ color: "success.main" }} />
        </ListItemIcon>
      )}
    </BaseSelectMenuItem>
  );
};
